import React, { useEffect, useState, Fragment } from 'react'
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import { useDispatch, useSelector } from 'react-redux'
import { diaAnterior, diaPosterior, formato_monto, formato_rut, reset_formato_rut } from '../../../common/Formatos'
import { obtenerDatosPantalla } from '../../../store/actions/implicado-action'
import { isValidParam } from '../../../common/Formatos'

const DatosGeneralesModal = ({ ID, formik, setReclama, isImplicado, setTipoInvolucradoTmp }) => {
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const data_datos_implicado = useSelector((state) => state.implicadoReducer)
  const { datosPantalla, comboSeguro, cfg_form37, comboCompanias, comboVehiculos, comboMarcas, parametros, comboTipoInvolucrado, comboLesionado, comboGestion } = data_datos_implicado
  const { antecedentesCasos } = data_datos_generales

  const [datosSiniestro, setDatosSiniestro] = useState({})
  //Estados de los campos del formulario
  const [rut, setRut] = useState('')
  const [nombre, setNombre] = useState('')
  const [gestion, setGestion] = useState('')

  const [fechaSin, setFecha] = useState('')
  const [seguro, setSeguro] = useState("")
  const [compania, setCompania] = useState("")
  const [siniestro, setSiniestro] = useState("")
  const [fechaSiniestro, setFechaSiniestro] = useState("")
  const [vehiculo, setTipoVehiculo] = useState("")
  const [patente, setPatente] = useState("")
  const [marca, setMarca] = useState("")
  const [descripcion, setDescripcion] = useState("")
  const [tipoInvolucrado, setTipoInvolucrado] = useState("")
  const [lesionado, setLesionado] = useState("")
  const [isChecked, setIsChecked] = useState(true)
  const [isChecked1, setIsChecked1] = useState(false)
  const [reclamacion, setReclamacion] = useState(false)

  useEffect(() => {
    setReclama(reclamacion)
  }, [reclamacion])

  useEffect(() => {
    setFecha(
      antecedentesCasos &&
      antecedentesCasos.antecedentesCasos[0]['FechaSiniestroFormat']
    )
  }, [antecedentesCasos])
  useEffect(() => {
    if (!isImplicado && datosPantalla?.datosPantalla[0]) {
      setSeguro(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.datosPantalla[0]['IdSeguroImplicado']
        ? datosPantalla.datosPantalla[0]['IdSeguroImplicado']
        : "")
      setCompania(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.datosPantalla[0]['IdCiaImplicado']
        ? datosPantalla.datosPantalla[0]['IdCiaImplicado']
        : "")
      setSiniestro(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.datosPantalla[0]['SiniestroIM']
        ? datosPantalla.datosPantalla[0]['SiniestroIM']
        : "")
      setFechaSiniestro(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.length !== null && datosPantalla.length !== ''
        ? convertirFecha(datosPantalla.datosPantalla[0]['FechaSiniestroIMFormat'] ?? datosPantalla.datosPantalla[0]['FechaSiniestroFormat'])
        : "")
      setTipoVehiculo(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.length !== null && datosPantalla.length !== '' && datosPantalla.datosPantalla[0]['IdTipoVehiculo']
        ? datosPantalla.datosPantalla[0]['IdTipoVehiculo']
        : "")
      setPatente(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.length !== null && datosPantalla.length !== '' && datosPantalla.datosPantalla[0]['Patente']
        ? datosPantalla.datosPantalla[0]['Patente']
        : "")
      setMarca(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.length !== null && datosPantalla.length !== '' && datosPantalla.datosPantalla[0]['IdMarca']
        ? datosPantalla.datosPantalla[0]['IdMarca']
        : "")
      setDescripcion(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.length !== null && datosPantalla.length !== '' && datosPantalla.datosPantalla[0]['Descripcion']
        ? datosPantalla.datosPantalla[0]['Descripcion']
        : "")
      //ojo pendiente
      setTipoInvolucrado(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.length !== null && datosPantalla.length !== '' && datosPantalla.datosPantalla[0]['TipoInvolucrado']
        ? datosPantalla.datosPantalla[0]['TipoInvolucrado']
        : "")
      setLesionado(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.datosPantalla[0]['ImplLesionado'] !== null && datosPantalla.length !== '' && datosPantalla.datosPantalla[0]['ImplLesionado']
        ? datosPantalla.datosPantalla[0]['ImplLesionado']
        : 203001)

      if (!datosPantalla || datosPantalla.length === 'undefined' || datosPantalla.length === '' || !datosPantalla.datosPantalla[0]['Reclamacion']) {
        setIsChecked(true)
        setIsChecked1(false)
        setReclamacion(0)
      } else if (datosPantalla && datosPantalla.datosPantalla[0]['Reclamacion'] === 0) {
        setIsChecked(true)
        setIsChecked1(false)
        setReclamacion(0)
      } else {
        setIsChecked(false)
        setIsChecked1(true)
        setReclamacion(1)
      }
    }

  }, [datosPantalla])

  useEffect(() => {
    setRut('');
    setNombre('');
    setGestion('');
    setTipoInvolucrado('');
    setTipoVehiculo('');
    setPatente('');
    setMarca('');
    setDescripcion('');
    setLesionado('');
    setIsChecked(true);
    setIsChecked1(false);
    setReclamacion(true);
    setSeguro('');
    setCompania('');
    setSiniestro('');
    setFecha('');
  }, [])

  const handleChangeReclama = (e) => {
    setReclamacion(e.target.value)

    setIsChecked(!isChecked)
    setIsChecked1(!isChecked1)
  }

  /* useEffect(() => {
    if (!isImplicado) {
      if (datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.datosPantalla[0]['Reclamacion'] !== null && datosPantalla.length !== '') {
        setIsChecked(true)
        setIsChecked1(false)
      } else {
        setIsChecked(false)
        setIsChecked1(true)

      }


      setIsChecked1(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.datosPantalla[0]['Reclamacion'] !== null && datosPantalla.length !== ''
        ? false
        : true)

    } else {
      setIsChecked(true)
    }

  }, [datosPantalla, isImplicado]) */

  /* useEffect(() => {
    if (!isImplicado) {
      setIsChecked(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.datosPantalla[0]['Reclamacion'] !== null && datosPantalla.length !== ''
        ? false
        : true)
      setIsChecked1(datosPantalla && datosPantalla.length !== 'undefined' && datosPantalla.datosPantalla[0]['Reclamacion'] !== null && datosPantalla.length !== ''
        ? true
        : false)

    } else {
      setIsChecked(true)
    }

  }, []) */

  useEffect(() => {
    if (comboGestion) {
      comboGestion.comboGestion.forEach(element => { if (element.id === 207002) setGestion(element.id) });
    }
  }, [comboGestion])

  const convertirFecha = (fecha) => {
    if (fecha !== null && typeof fecha !== undefined) {

      const [dia, mes, ano] = fecha?.split('-')
      const fechaFormat = [ano, mes, dia].join('-')

      return fechaFormat
    } else return ''
  }

  const hoy = () => {
    const fecha = new Date()
    const hoy = fecha.toISOString().split('T')[0]
    return hoy
  }

  const resetValues = (value) => {
    if (value && value !== 205001) {
      setSeguro("");
      setCompania("");
      setSiniestro("");
      setFechaSiniestro("");
    }
  }

  return (
    <>
      <style type='text/css'>
          {`
          .is_required:after {
              content: "*";
              margin-left: 2px;
              color: #000;
              font-weight: 500;
              font-size: 12pt;
          }
          form label {
              font-weight: bold;
              font-size: 14px;
              margin-bottom: 0;
              margin-top: 5px;
              margin-top: 2px
          }
      `}
      </style>
      <Card>
        <Card.Header as='h6' className='text-center' style={{ backgroundColor: '#4F517A', color: 'white' }}>
          {isImplicado ? cfg_form37 && cfg_form37.cfg_form37['casograldefensa-nvoimpl-title']  : cfg_form37 && cfg_form37.cfg_form37['casograldefensa-editimpl-title-terimplicado'] + ' (' + ID + ')'}
        </Card.Header>
        <Container>
          {cfg_form37 ? (
            <div>
              <Container>

                <Row className='mt-2'>
                  <Col md='3'>
                    <Form.Label
                      className="is_required"
                      style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '0' }}
                    >
                      {
                        cfg_form37.cfg_form37[
                        'casograldefensa-editimpl-terimplrut'
                        ]
                      }
                    </Form.Label>{' '}
                    <br />
                    {!isImplicado ?
                      <Form.Text className='mb-3'>
                        {(datosPantalla && datosPantalla.datosPantalla[0] && isValidParam(datosPantalla.datosPantalla[0]['RutInvolucrado']))
                          ? formato_rut(datosPantalla.datosPantalla[0]['RutInvolucrado'])
                          : ''}
                      </Form.Text> :
                      <>
                        <Form.Control
                          className='mt-2 w-75'
                          name='rutImplicadoTercero'
                          value={formik.values.rutImplicadoTercero = rut}
                          onChange={e => { formik.handleChange(e); setRut(e.target.value) }}
                          onBlur={() => { setRut(formato_rut(rut)) }}
                          onFocus={() => { setRut(reset_formato_rut(rut)) }}
                          error={formik.errors.rutImplicadoTercero}>
                        </Form.Control>
                        {formik.errors.rutImplicadoTercero &&
                          <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.rutImplicadoTercero}
                          </Form.Text>
                        }
                      </>
                    }
                  </Col>
                  <Col md='3'>
                    <Form.Label
                      className="is_required"
                      style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '0' }}
                    >
                      {
                        cfg_form37.cfg_form37[
                        'casograldefensa-editimpl-terimplnombre'
                        ]
                      }
                    </Form.Label>
                    <br />
                    {!isImplicado ?
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {(datosPantalla && datosPantalla.datosPantalla[0] && isValidParam(datosPantalla.datosPantalla[0]['NombreInvolucrado']))
                          ? datosPantalla.datosPantalla[0]['NombreInvolucrado']
                          : ''}
                      </Form.Text> :
                      <>
                        <Form.Control
                          className='mt-2 w-75'
                          name='nombreInvolucradoTercero'
                          value={formik.values.nombreInvolucradoTercero = nombre}
                          onChange={e => { formik.handleChange(e); setNombre(e.target.value) }}>
                        </Form.Control>
                        {formik.errors.nombreInvolucradoTercero &&
                          <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.nombreInvolucradoTercero}
                          </Form.Text>
                        }
                      </>
                    }
                  </Col>
                  <Col md='3'>
                    <Form.Label
                      className='mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form37.cfg_form37[
                        'casograldefensa-editimpl-terimplgestaplic'
                        ]
                      }
                    </Form.Label>
                    <br />
                    {!isImplicado ?
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {(datosPantalla && datosPantalla.datosPantalla[0] && isValidParam(datosPantalla.datosPantalla[0]['GlosaTipoGestion']))
                          ? datosPantalla.datosPantalla[0]['GlosaTipoGestion']
                          : ''}
                      </Form.Text> :
                      <Form.Select
                        className='mt-2 w-75'
                        aria-label='Default select example'
                        disabled
                        name='gestion'
                        value={(formik.values.gestion = gestion)}
                        onChange={(e) => { formik.handleChange(e); setGestion(e.target.value) }}>

                        <option value={''}>Seleccione...</option>
                        {comboGestion && comboGestion.comboGestion.map((c) => (
                          <option key={c.id} value={c.id}>{c.nombre}</option>
                        ))}
                      </Form.Select>
                    }
                  </Col>

                  <Col md='3'>
                    <Form.Label
                      className='mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form37.cfg_form37[
                        'casograldefensa-editimpl-terimplestado'
                        ]
                      }
                    </Form.Label>
                    <br />
                    {!isImplicado ?
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {(datosPantalla && datosPantalla.datosPantalla[0] && isValidParam(datosPantalla.datosPantalla[0]['EstadoImplicado']))
                          ? datosPantalla.datosPantalla[0]['EstadoImplicado']
                          : ''}
                      </Form.Text> :
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {cfg_form37.cfg_form37['casograldefensa-editimpl-terimplestadolbl']}
                      </Form.Text>
                    }
                  </Col>
                </Row>
              </Container>

              <Container>
                <Row className='mt-2'>
                  <Col md='3'>
                    <Form.Label
                      className="is_required"
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form37.cfg_form37[
                        'casograldefensa-editimpl-terimplterinvol'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Select
                      className='mt-2 w-75'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e);
                        setTipoInvolucrado(parseInt(e.target.value));
                        setTipoInvolucradoTmp(parseInt(e.target.value));
                        resetValues(parseInt(e.target.value));
                      }}

                      name='tipoInvolucrado'
                      value={(formik.values.tipoInvolucrado = tipoInvolucrado)}
                      error={formik.errors.tipoInvolucrado}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboTipoInvolucrado && comboTipoInvolucrado.comboTipoInvolucrado.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                        </option>
                      ))}
                    </Form.Select>
                    {formik.errors.tipoInvolucrado ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.tipoInvolucrado}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </Col>
                  <Col md='3'>
                    <Form.Label
                      className='mt-2 mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form37.cfg_form37[
                        'casograldefensa-editimpl-terimpltipovh'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Select
                      disabled={tipoInvolucrado && tipoInvolucrado !== 205001}
                      className='mt-2 w-75'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e)

                        setTipoVehiculo(e.target.value)

                      }}
                      name='tipoVehiculo'
                      value={(formik.values.tipoVehiculo = vehiculo)}
                      error={formik.errors.tipoVehiculo}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboVehiculos && comboVehiculos.comboVehiculos.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                        </option>
                      ))}
                    </Form.Select>
                    {formik.errors.tipoVehiculo ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.tipoVehiculo}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </Col>
                  <Col md='3'>
                    <Form.Label
                      className='mt-2 mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form37.cfg_form37[
                        'casograldefensa-editimpl-terimplpatente'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Control
                      disabled={tipoInvolucrado && tipoInvolucrado !== 205001}
                      className='mt-2 w-75'
                      aria-label='Default select example'
                      onChange={e => {
                        formik.handleChange(e)
                        setPatente(e.target.value)
                      }}
                      name='patente'

                      value={formik.values.patente = patente
                      }
                      error={formik.errors.patente}
                    ></Form.Control>
                    {formik.errors.patente ? (<Form.Text variant="danger" style={{ color: "red" }} >{formik.errors.patente}</Form.Text>) : ""}
                  </Col>
                  <Col md='3'>
                    <Form.Label
                      className='mt-2 mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form37.cfg_form37[
                        'casograldefensa-editimpl-terimplmarca'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Select
                      disabled={tipoInvolucrado && tipoInvolucrado !== 205001}
                      className='mt-2 w-75'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e)

                        setMarca(e.target.value)

                      }}
                      name='marcaVehiculo'
                      value={(formik.values.marcaVehiculo = marca)}
                      error={formik.errors.marcaVehiculo}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboMarcas && comboMarcas.comboMarcas.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                        </option>
                      ))}
                    </Form.Select>
                    {formik.errors.marcaVehiculo ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.marcaVehiculo}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col md='6'>
                    <Form.Label
                      className='mt-3 mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form37.cfg_form37[
                        'casograldefensa-editimpl-terimpldesc'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Control as="textarea" className='mt-2 mb-2' rows={2}
                      onChange={e => {
                        formik.handleChange(e)
                        setDescripcion(e.target.value)

                      }}
                      name='detalleDescripcion'

                      value={formik.values.detalleDescripcion = descripcion
                      }
                      error={formik.errors.detalleDescripcion}

                    />
                    {formik.errors.detalleDescripcion ? (<Form.Text variant="danger" style={{ color: "red" }} >{formik.errors.detalleDescripcion}</Form.Text>) : ""}
                  </Col>
                  <Col md='3'>
                    <Form.Label
                      className='mt-3 mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form37.cfg_form37[
                        'casograldefensa-editimpl-terimplimpllesionado'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Select
                      className='mt-2 w-75'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e)

                        setLesionado(e.target.value)

                      }}
                      name='lesionado'
                      value={(formik.values.lesionado = lesionado)}
                      error={formik.errors.lesionado}
                    >
                      {comboLesionado && comboLesionado.comboLesionado.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                        </option>
                      ))}
                    </Form.Select>
                    {formik.errors.lesionado ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.lesionado}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </Col>
                  <Col className="mt-3">
                    <Form.Text
                      style={
                        {
                          fontWeight: 'bold',
                          fontSize: '16px',
                          color: 'black'

                        }
                      }>
                      {cfg_form37.cfg_form37['casograldefensa-editimpl-terimplpresreclama']}
                    </Form.Text>

                    <br />
                    <div className='mt-3 d-flex'>
                      <Form.Check label="No" name="group1" type='radio' id='sin' value='0'
                        checked={isChecked}
                        onChange={
                          (e) => handleChangeReclama(e)
                        } />

                      <Form.Check label="Si" name="group1" type='radio' id='con' value='1' className='mx-5'
                        checked={isChecked1}
                        onChange={
                          (e) => handleChangeReclama(e)
                        } />

                    </div>

                  </Col>
                </Row>
                <hr style={{ color: '#04005D', height: '2px', marginBottom: '2px', marginTop: '5px' }}></hr>



              </Container>
              <Container>
                <Row>
                  <Col>
                    <Form.Label
                      className='mt-3 mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form37.cfg_form37[
                        'casograldefensa-editimpl-terimplseguro'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Select
                      className='mt-2 w-75'
                      aria-label='Default select example'
                      disabled={tipoInvolucrado && tipoInvolucrado !== 205001}
                      onChange={(e) => {
                        formik.handleChange(e)

                        setSeguro(e.target.value)

                      }}
                      name='seguro'
                      value={(formik.values.seguro = seguro)}
                      error={formik.errors.seguro}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboSeguro && comboSeguro.comboSeguro?.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                        </option>
                      ))}
                    </Form.Select>
                    {formik.errors.seguro ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.seguro}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </Col>
                  <Col>
                    <Form.Label
                      className='mt-3 mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form37.cfg_form37[
                        'casograldefensa-editimpl-terimplcia'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Select
                      className='mt-2 w-75'
                      aria-label='Default select example'
                      disabled={tipoInvolucrado && tipoInvolucrado !== 205001}
                      onChange={(e) => {
                        formik.handleChange(e)

                        setCompania(e.target.value)

                      }}
                      name='idCompania'
                      value={(formik.values.idCompania = compania)}
                      error={formik.errors.idCompania}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboCompanias && comboCompanias.comboCompanias.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                        </option>
                      ))}
                    </Form.Select>
                    {formik.errors.idCompania ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.idCompania}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </Col>

                  <Col>
                    <Form.Label
                      className='mt-3 mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form37.cfg_form37[
                        'casograldefensa-editimpl-terimplsinciaimpl'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Control
                      className='mt-2 w-75'
                      aria-label='Default select example'
                      disabled={tipoInvolucrado && tipoInvolucrado !== 205001}
                      onChange={e => {
                        formik.handleChange(e)
                        setSiniestro(e.target.value)
                      }}
                      name='idSiniestroIM'

                      value={formik.values.idSiniestroIM = siniestro
                      }
                      error={formik.errors.idSiniestroIM}
                    ></Form.Control>
                    {formik.errors.idSiniestroIM ? (<Form.Text variant="danger" style={{ color: "red" }} >{formik.errors.idSiniestroIM}</Form.Text>) : ""}
                  </Col>
                  <Col>
                    <Form.Label
                      className='mt-3 mb-0'
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      {
                        cfg_form37.cfg_form37[
                        'casograldefensa-editimpl-terimplfechsiniimpl'
                        ]
                      }
                    </Form.Label>
                    <br />
                    <Form.Control
                      className='mt-2 w-75'
                      aria-label='Default select example'
                      disabled={tipoInvolucrado && tipoInvolucrado !== 205001}
                      type="date"
                      min={
                        fechaSin && parametros &&
                        diaAnterior(fechaSin, parametros.parametros['valorParametro'])
                      }
                      max={fechaSin && parametros && diaPosterior(fechaSin, parametros.parametros['valorParametro'])}
                      onChange={e => {
                        formik.handleChange(e)
                        setFechaSiniestro(e.target.value)
                      }}
                      name='fechaSiniestroIM'

                      value={formik.values.fechaSiniestroIM = fechaSiniestro
                      }
                      error={formik.errors.fechaSiniestroIM}

                    ></Form.Control>
                    {formik.errors.fechaSiniestroIM ? (<Form.Text variant="danger" style={{ color: "red" }} >{formik.errors.fechaSiniestroIM}</Form.Text>) : ""}
                  </Col>
                  <hr style={{ color: '#04005D', height: '2px', marginBottom: '10px', marginTop: '15px' }}></hr>
                </Row>
              </Container>
            </div>
          ) : ''}
        </Container>
      </Card>
    </>
  )
}

export default DatosGeneralesModal
